import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _02761988 = () => interopDefault(import('../../../src/pages/about.vue' /* webpackChunkName: "pages/about" */))
const _71034368 = () => interopDefault(import('../../../src/pages/account.vue' /* webpackChunkName: "pages/account" */))
const _269d8300 = () => interopDefault(import('../../../src/pages/bsg-terms-and-conditions.vue' /* webpackChunkName: "pages/bsg-terms-and-conditions" */))
const _26ac7073 = () => interopDefault(import('../../../src/pages/careers/index.vue' /* webpackChunkName: "pages/careers/index" */))
const _08031c51 = () => interopDefault(import('../../../src/pages/connect-wallet.vue' /* webpackChunkName: "pages/connect-wallet" */))
const _c3266a46 = () => interopDefault(import('../../../src/pages/contact-support.vue' /* webpackChunkName: "pages/contact-support" */))
const _0858779c = () => interopDefault(import('../../../src/pages/distribution/index.vue' /* webpackChunkName: "pages/distribution/index" */))
const _9d763502 = () => interopDefault(import('../../../src/pages/environmentalimpact.vue' /* webpackChunkName: "pages/environmentalimpact" */))
const _8675a7c4 = () => interopDefault(import('../../../src/pages/game-auth.vue' /* webpackChunkName: "pages/game-auth" */))
const _b5ce8028 = () => interopDefault(import('../../../src/pages/game-lock-allowance.vue' /* webpackChunkName: "pages/game-lock-allowance" */))
const _6fc60f82 = () => interopDefault(import('../../../src/pages/games/index.vue' /* webpackChunkName: "pages/games/index" */))
const _c4cbda8a = () => interopDefault(import('../../../src/pages/get-gala.vue' /* webpackChunkName: "pages/get-gala" */))
const _a71812a4 = () => interopDefault(import('../../../src/pages/hiring-privacy-policy.vue' /* webpackChunkName: "pages/hiring-privacy-policy" */))
const _6b980f9a = () => interopDefault(import('../../../src/pages/inventory/index.vue' /* webpackChunkName: "pages/inventory/index" */))
const _7a71e6a6 = () => interopDefault(import('../../../src/pages/launcher-eula.vue' /* webpackChunkName: "pages/launcher-eula" */))
const _e15e9f08 = () => interopDefault(import('../../../src/pages/loggedin.vue' /* webpackChunkName: "pages/loggedin" */))
const _2854d138 = () => interopDefault(import('../../../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _34a2ac2f = () => interopDefault(import('../../../src/pages/nodes/index.vue' /* webpackChunkName: "pages/nodes/index" */))
const _26125b3a = () => interopDefault(import('../../../src/pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _23e90b70 = () => interopDefault(import('../../../src/pages/pkce-callback.vue' /* webpackChunkName: "pages/pkce-callback" */))
const _715b60a8 = () => interopDefault(import('../../../src/pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _66a8a8b1 = () => interopDefault(import('../../../src/pages/redeem.vue' /* webpackChunkName: "pages/redeem" */))
const _0b2d96f8 = () => interopDefault(import('../../../src/pages/register.vue' /* webpackChunkName: "pages/register" */))
const _52e0a417 = () => interopDefault(import('../../../src/pages/registered.vue' /* webpackChunkName: "pages/registered" */))
const _1e6ae8b1 = () => interopDefault(import('../../../src/pages/results.vue' /* webpackChunkName: "pages/results" */))
const _0f2d3305 = () => interopDefault(import('../../../src/pages/social/index.vue' /* webpackChunkName: "pages/social/index" */))
const _91adb648 = () => interopDefault(import('../../../src/pages/store.vue' /* webpackChunkName: "pages/store" */))
const _bb93546e = () => interopDefault(import('../../../src/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _71efed71 = () => interopDefault(import('../../../src/pages/twd-giveaway-terms-and-conditions.vue' /* webpackChunkName: "pages/twd-giveaway-terms-and-conditions" */))
const _611e7852 = () => interopDefault(import('../../../src/pages/upgrade.vue' /* webpackChunkName: "pages/upgrade" */))
const _2d52dec6 = () => interopDefault(import('../../../src/pages/verify-email.vue' /* webpackChunkName: "pages/verify-email" */))
const _5c1a1476 = () => interopDefault(import('../../../src/pages/verify-ip.vue' /* webpackChunkName: "pages/verify-ip" */))
const _4c86436e = () => interopDefault(import('../../../src/pages/careers/job-listings.vue' /* webpackChunkName: "pages/careers/job-listings" */))
const _0bcb72c6 = () => interopDefault(import('../../../src/pages/connectedAccounts/epic/index.vue' /* webpackChunkName: "pages/connectedAccounts/epic/index" */))
const _ffe9b564 = () => interopDefault(import('../../../src/pages/connectedAccounts/steam/index.vue' /* webpackChunkName: "pages/connectedAccounts/steam/index" */))
const _160f7ce2 = () => interopDefault(import('../../../src/pages/external/register.vue' /* webpackChunkName: "pages/external/register" */))
const _6f5e95ba = () => interopDefault(import('../../../src/pages/nodes/buy.vue' /* webpackChunkName: "pages/nodes/buy" */))
const _508f9add = () => interopDefault(import('../../../src/pages/nodes/ecosystem.vue' /* webpackChunkName: "pages/nodes/ecosystem" */))
const _91011a3e = () => interopDefault(import('../../../src/pages/nodes/headless-linux-install.vue' /* webpackChunkName: "pages/nodes/headless-linux-install" */))
const _18fcb773 = () => interopDefault(import('../../../src/pages/nodes/last-expedition-operator-node.vue' /* webpackChunkName: "pages/nodes/last-expedition-operator-node" */))
const _54ba4430 = () => interopDefault(import('../../../src/pages/nodes/mint-dialog.vue' /* webpackChunkName: "pages/nodes/mint-dialog" */))
const _23516320 = () => interopDefault(import('../../../src/pages/nodes/my-licenses.vue' /* webpackChunkName: "pages/nodes/my-licenses" */))
const _96d059c0 = () => interopDefault(import('../../../src/pages/nodes/my-node.vue' /* webpackChunkName: "pages/nodes/my-node" */))
const _3be39bfa = () => interopDefault(import('../../../src/pages/nodes/my-nodes.vue' /* webpackChunkName: "pages/nodes/my-nodes" */))
const _bcc8e6d8 = () => interopDefault(import('../../../src/pages/nodes/spider-tanks.vue' /* webpackChunkName: "pages/nodes/spider-tanks" */))
const _69758f30 = () => interopDefault(import('../../../src/pages/nodes/spider-tanks-planetary-node.vue' /* webpackChunkName: "pages/nodes/spider-tanks-planetary-node" */))
const _718b8047 = () => interopDefault(import('../../../src/pages/simplex/order-history.vue' /* webpackChunkName: "pages/simplex/order-history" */))
const _3b577f88 = () => interopDefault(import('../../../src/pages/social/friends.vue' /* webpackChunkName: "pages/social/friends" */))
const _9989b20c = () => interopDefault(import('../../../src/pages/games/items/top-sellers.vue' /* webpackChunkName: "pages/games/items/top-sellers" */))
const _14d9bb9a = () => interopDefault(import('../../../src/pages/inventory/nfts/item.vue' /* webpackChunkName: "pages/inventory/nfts/item" */))
const _7e548406 = () => interopDefault(import('../../../src/pages/connectedAccounts/steam/_slug.vue' /* webpackChunkName: "pages/connectedAccounts/steam/_slug" */))
const _51a27cc8 = () => interopDefault(import('../../../src/pages/games/buy-item/_id.vue' /* webpackChunkName: "pages/games/buy-item/_id" */))
const _14a9f96d = () => interopDefault(import('../../../src/pages/inventory/nfts/_category.vue' /* webpackChunkName: "pages/inventory/nfts/_category" */))
const _37ff8148 = () => interopDefault(import('../../../src/pages/connectedAccounts/steam/_game/_slug.vue' /* webpackChunkName: "pages/connectedAccounts/steam/_game/_slug" */))
const _4770c01a = () => interopDefault(import('../../../src/pages/games/_name/index.vue' /* webpackChunkName: "pages/games/_name/index" */))
const _256e52ff = () => interopDefault(import('../../../src/pages/inventory/_symbol.vue' /* webpackChunkName: "pages/inventory/_symbol" */))
const _6b84701c = () => interopDefault(import('../../../src/pages/games/_name/play.vue' /* webpackChunkName: "pages/games/_name/play" */))
const _5c5b598e = () => interopDefault(import('../../../src/pages/games/_name/your-items.vue' /* webpackChunkName: "pages/games/_name/your-items" */))
const _668303be = () => interopDefault(import('../../../src/pages/nodes/_name/buy.vue' /* webpackChunkName: "pages/nodes/_name/buy" */))
const _222df44d = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _02761988,
    name: "about"
  }, {
    path: "/account",
    component: _71034368,
    name: "account"
  }, {
    path: "/bsg-terms-and-conditions",
    component: _269d8300,
    name: "bsg-terms-and-conditions"
  }, {
    path: "/careers",
    component: _26ac7073,
    name: "careers"
  }, {
    path: "/connect-wallet",
    component: _08031c51,
    name: "connect-wallet"
  }, {
    path: "/contact-support",
    component: _c3266a46,
    name: "contact-support"
  }, {
    path: "/distribution",
    component: _0858779c,
    name: "distribution"
  }, {
    path: "/environmentalimpact",
    component: _9d763502,
    name: "environmentalimpact"
  }, {
    path: "/game-auth",
    component: _8675a7c4,
    name: "game-auth"
  }, {
    path: "/game-lock-allowance",
    component: _b5ce8028,
    name: "game-lock-allowance"
  }, {
    path: "/games",
    component: _6fc60f82,
    name: "games"
  }, {
    path: "/get-gala",
    component: _c4cbda8a,
    name: "get-gala"
  }, {
    path: "/hiring-privacy-policy",
    component: _a71812a4,
    name: "hiring-privacy-policy"
  }, {
    path: "/inventory",
    component: _6b980f9a,
    name: "inventory"
  }, {
    path: "/launcher-eula",
    component: _7a71e6a6,
    name: "launcher-eula"
  }, {
    path: "/loggedin",
    component: _e15e9f08,
    name: "loggedin"
  }, {
    path: "/login",
    component: _2854d138,
    name: "login"
  }, {
    path: "/nodes",
    component: _34a2ac2f,
    name: "nodes"
  }, {
    path: "/notifications",
    component: _26125b3a,
    name: "notifications"
  }, {
    path: "/pkce-callback",
    component: _23e90b70,
    name: "pkce-callback"
  }, {
    path: "/privacy-policy",
    component: _715b60a8,
    name: "privacy-policy"
  }, {
    path: "/redeem",
    component: _66a8a8b1,
    name: "redeem"
  }, {
    path: "/register",
    component: _0b2d96f8,
    name: "register"
  }, {
    path: "/registered",
    component: _52e0a417,
    name: "registered"
  }, {
    path: "/results",
    component: _1e6ae8b1,
    name: "results"
  }, {
    path: "/social",
    component: _0f2d3305,
    name: "social"
  }, {
    path: "/store",
    component: _91adb648,
    name: "store"
  }, {
    path: "/terms-and-conditions",
    component: _bb93546e,
    name: "terms-and-conditions"
  }, {
    path: "/twd-giveaway-terms-and-conditions",
    component: _71efed71,
    name: "twd-giveaway-terms-and-conditions"
  }, {
    path: "/upgrade",
    component: _611e7852,
    name: "upgrade"
  }, {
    path: "/verify-email",
    component: _2d52dec6,
    name: "verify-email"
  }, {
    path: "/verify-ip",
    component: _5c1a1476,
    name: "verify-ip"
  }, {
    path: "/careers/job-listings",
    component: _4c86436e,
    name: "careers-job-listings"
  }, {
    path: "/connectedAccounts/epic",
    component: _0bcb72c6,
    name: "connectedAccounts-epic"
  }, {
    path: "/connectedAccounts/steam",
    component: _ffe9b564,
    name: "connectedAccounts-steam"
  }, {
    path: "/external/register",
    component: _160f7ce2,
    name: "external-register"
  }, {
    path: "/nodes/buy",
    component: _6f5e95ba,
    name: "nodes-buy"
  }, {
    path: "/nodes/ecosystem",
    component: _508f9add,
    name: "nodes-ecosystem"
  }, {
    path: "/nodes/headless-linux-install",
    component: _91011a3e,
    name: "nodes-headless-linux-install"
  }, {
    path: "/nodes/last-expedition-operator-node",
    component: _18fcb773,
    name: "nodes-last-expedition-operator-node"
  }, {
    path: "/nodes/mint-dialog",
    component: _54ba4430,
    name: "nodes-mint-dialog"
  }, {
    path: "/nodes/my-licenses",
    component: _23516320,
    name: "nodes-my-licenses"
  }, {
    path: "/nodes/my-node",
    component: _96d059c0,
    name: "nodes-my-node"
  }, {
    path: "/nodes/my-nodes",
    component: _3be39bfa,
    name: "nodes-my-nodes"
  }, {
    path: "/nodes/spider-tanks",
    component: _bcc8e6d8,
    name: "nodes-spider-tanks"
  }, {
    path: "/nodes/spider-tanks-planetary-node",
    component: _69758f30,
    name: "nodes-spider-tanks-planetary-node"
  }, {
    path: "/simplex/order-history",
    component: _718b8047,
    name: "simplex-order-history"
  }, {
    path: "/social/friends",
    component: _3b577f88,
    name: "social-friends"
  }, {
    path: "/games/items/top-sellers",
    component: _9989b20c,
    name: "games-items-top-sellers"
  }, {
    path: "/inventory/nfts/item",
    component: _14d9bb9a,
    name: "inventory-nfts-item"
  }, {
    path: "/connectedAccounts/steam/:slug",
    component: _7e548406,
    name: "connectedAccounts-steam-slug"
  }, {
    path: "/games/buy-item/:id?",
    component: _51a27cc8,
    name: "games-buy-item-id"
  }, {
    path: "/inventory/nfts/:category?",
    component: _14a9f96d,
    name: "inventory-nfts-category"
  }, {
    path: "/connectedAccounts/steam/:game/:slug?",
    component: _37ff8148,
    name: "connectedAccounts-steam-game-slug"
  }, {
    path: "/games/:name",
    component: _4770c01a,
    name: "games-name"
  }, {
    path: "/inventory/:symbol",
    component: _256e52ff,
    name: "inventory-symbol"
  }, {
    path: "/games/:name/play",
    component: _6b84701c,
    name: "games-name-play"
  }, {
    path: "/games/:name/your-items",
    component: _5c5b598e,
    name: "games-name-your-items"
  }, {
    path: "/nodes/:name/buy",
    component: _668303be,
    name: "nodes-name-buy"
  }, {
    path: "/",
    component: _222df44d,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
